import {
  EnqueteTemplateModel,
  EnqueteTemplateGetAttributes,
  EnqueteTemplateSendAttributes,
  EnqueteTemplateCollection,
} from 'src/models/EnqueteTemplateModel';
import { Notify } from 'quasar';
import {
  EnqueteTemplateAdapterInteface,
  ListEnqueteTemplatesInput as BaseListEnqueteTemplatesInput,
} from 'src/adapter/EnqueteTemplateAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListEnqueteTemplatesInput = BaseListEnqueteTemplatesInput;
export class EnqueteTemplateApiClass {
  adapter: EnqueteTemplateAdapterInteface;
  constructor(adapter: EnqueteTemplateAdapterInteface) {
    this.adapter = adapter;
  }
  async listEnqueteTemplates(
    conditions?: ListEnqueteTemplatesInput
  ): Promise<{ total: number; data: EnqueteTemplateCollection }> {
    try {
      conditions?.page;
      const res = await this.adapter.listEnqueteTemplates(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (enqueteTemplate: EnqueteTemplateGetAttributes) =>
            new EnqueteTemplateModel(enqueteTemplate)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getEnqueteTemplate(id: string): Promise<EnqueteTemplateModel> {
    try {
      const enqueteTemplate = await this.adapter.getEnqueteTemplate(id);
      return new EnqueteTemplateModel(enqueteTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createEnqueteTemplate(
    attributes: EnqueteTemplateSendAttributes
  ): Promise<EnqueteTemplateModel> {
    try {
      const enqueteTemplate = await this.adapter.createEnqueteTemplate(
        attributes
      );
      return new EnqueteTemplateModel(enqueteTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateEnqueteTemplate(
    id: string,
    attributes: EnqueteTemplateSendAttributes
  ): Promise<EnqueteTemplateModel> {
    try {
      const enqueteTemplate = await this.adapter.updateEnqueteTemplate(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new EnqueteTemplateModel(enqueteTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteEnqueteTemplate(id: string): Promise<boolean> {
    try {
      const res = this.adapter.deleteEnqueteTemplate(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
